<template>
  <div>
    <div>
      <div class="ba-question-wrapper">
        <span v-if="questionText" class="ba-question-text" v-html="questionText"></span>
      </div>
      <slot v-if="questionText && description" name="description">
        <div class="ba-description-wrapper mb-2">
          <span v-if="description" class="ba-description" v-html="description"></span>
          <span v-if="descriptionTooltip && description" class="borrower-attribute-tooltip">
            <a>
              <div class="tooltip-wrapper">
                <LendioBootstrapTooltip>
                  <span class="tooltip-trigger" data-bs-toggle="tooltip" data-bs-placement="right"
                    :title="descriptionTooltip"></span>
                </LendioBootstrapTooltip>
                <fa-icon :icon="['far', 'circle-question']" class="fa-circle-question"></fa-icon>
              </div>
            </a>
          </span>
        </div>
      </slot>
      <slot name="label">
        <label v-if="label" :for="labelFor || ''" class="ba-label mb-2">
          {{ label }}
          <span class="borrower-attribute-tooltip">
            <LendioBootstrapTooltip v-if="tooltipText">
              <span class="text-primary" data-bs-toggle="tooltip" data-bs-placement="right" :title="tooltipText">
                <fa-icon :icon="['fal', 'circle-info']"></fa-icon>
              </span>
            </LendioBootstrapTooltip>
          </span>
        </label>
      </slot>
      <slot v-if="!questionText && description" name="description">
        <div class="ba-description-wrapper mb-2">
          <span v-if="description" class="ba-description" v-html="description"></span>
          <span v-if="descriptionTooltip && description" class="borrower-attribute-tooltip">
            <a>
              <div class="tooltip-wrapper">
                <LendioBootstrapTooltip>
                  <span class="tooltip-trigger" data-bs-toggle="tooltip" data-bs-placement="right"
                    :title="descriptionTooltip"></span>
                </LendioBootstrapTooltip>
                <fa-icon :icon="['far', 'circle-question']" class="fa-circle-question"></fa-icon>
              </div>
            </a>
          </span>
        </div>
      </slot>
      <slot name="input"></slot>
      <slot name="helpText">
        <div class="ba-help-text mb-2 type-400" :class="{ 'mb-2': errorText || disclaimer }"
          v-if="helpText && !hideHelpText">
          <fa-icon :icon="['far', 'circle-info']"></fa-icon>
          <span> {{ helpText }} </span>
        </div>
      </slot>
      <slot name="errorText">
        <div class="ba-error-message mb-2 invalid-feedback d-block" :class="{ 'mb-2': disclaimer }" v-if="errorText">
          <fa-icon :icon="['fal', 'circle-exclamation']"></fa-icon> <span v-html="errorText"></span>
        </div>
      </slot>
      <slot name="disclaimer">
        <div class="p-xs" v-if="disclaimer" v-html="disclaimer"></div>
      </slot>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {}
  },
  props: {
    questionText: String,
    description: String,
    descriptionTooltip: String,
    label: String,
    tooltipText: String,
    helpText: String,
    errorText: String,
    disclaimer: String,
    focused: Boolean,
    labelFor: String,
    hideHelpText: Boolean,
  },
  created () {},
  computed: {},
  methods: {}
}
</script>
<style lang="scss">
.ba-disclaimer, .ba-description-wrapper {
    font-size: 12px;
}
</style>
